import type { Warning } from 'src/tpbp-core/models/warning/warnings.types'
import type { FieldsAndRelationsByOriginKey } from 'src/services/mappings/mapping.types'
import { isDevelopment } from 'src/tpbp-core/utils/common.utils'
import { logger } from 'src/utils/logger.utils'

export const getFormattedErrors = (
  fieldsAndRelationsByOriginKey: FieldsAndRelationsByOriginKey,
  errors: Warning[],
) => {
  if (!errors || errors.length === 0) {
    return {}
  }

  return errors.reduce<Record<string, string>>((formattedErrors, error) => {
    const { meta, detail } = error

    const originKey = meta?.attribute

    if (!originKey) {
      return formattedErrors
    }
    const field = fieldsAndRelationsByOriginKey[originKey]
    if (field) {
      const message = detail
      if (Object.hasOwn(formattedErrors, field.key)) {
        formattedErrors[field.key] += ` - ${message}`
      } else {
        formattedErrors[field.key] = message
      }
    } else if (isDevelopment) {
      logger.warn(`Unknown field '${originKey}'`)
    }

    return formattedErrors
  }, {})
}
